"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Address"));
__export(require("./CheckVersionResult"));
__export(require("./ClientAccount"));
__export(require("./ClientAccountEntry"));
__export(require("./ClientAchievement"));
__export(require("./ClientAchievementLevel"));
__export(require("./ClientActionDocumentation"));
__export(require("./ClientAddress"));
__export(require("./ClientAddressDefinition"));
__export(require("./ClientAddressListEntry"));
__export(require("./ClientApp"));
__export(require("./ClientAppVariant"));
__export(require("./ClientAppVariantChangeSelectedGeoAreasRequest"));
__export(require("./ClientAppVariantChangeSelectedGeoAreasResponse"));
__export(require("./ClientAppVariantUsageExtended"));
__export(require("./ClientChat"));
__export(require("./ClientChatExtended"));
__export(require("./ClientChatFlagRequest"));
__export(require("./ClientChatMessage"));
__export(require("./ClientChatMessageSendRequest"));
__export(require("./ClientChatMessageSentConfirmation"));
__export(require("./ClientChatParticipant"));
__export(require("./ClientChatReadRequest"));
__export(require("./ClientChatStartOnCommentConfirmation"));
__export(require("./ClientChatStartOnCommentRequest"));
__export(require("./ClientChatStartOnPostConfirmation"));
__export(require("./ClientChatStartOnPostRequest"));
__export(require("./ClientChatStartWithSuggestionWorkerConfirmation"));
__export(require("./ClientChatStartWithSuggestionWorkerRequest"));
__export(require("./ClientChatSubject"));
__export(require("./ClientComment"));
__export(require("./ClientCommentChangeConfirmation"));
__export(require("./ClientCommentChangeRequest"));
__export(require("./ClientCommentCreateConfirmation"));
__export(require("./ClientCommentCreateRequest"));
__export(require("./ClientCommentDeleteAllForPostRequest"));
__export(require("./ClientCommentDeleteConfirmation"));
__export(require("./ClientCommentDeleteRequest"));
__export(require("./ClientCommentFlagRequest"));
__export(require("./ClientCommunity"));
__export(require("./ClientConnectDeliveryWithSellingPointRequest"));
__export(require("./ClientConnectDeliveryWithSellingPointResponse"));
__export(require("./ClientContactPerson"));
__export(require("./ClientCreateRoleAssignmentRequest"));
__export(require("./ClientCreateRoleAssignmentResponse"));
__export(require("./ClientDelivery"));
__export(require("./ClientDeliveryCreatedEvent"));
__export(require("./ClientDeliveryReceivedRequest"));
__export(require("./ClientDeliveryReceivedResponse"));
__export(require("./ClientDeliveryStatusRecord"));
__export(require("./ClientDimension"));
__export(require("./ClientExceptionEntity"));
__export(require("./ClientExternalPostPublishConfirmation"));
__export(require("./ClientFeature"));
__export(require("./ClientGeoArea"));
__export(require("./ClientGeoAreaExtended"));
__export(require("./ClientGossip"));
__export(require("./ClientGossipChangeRequest"));
__export(require("./ClientGossipCreateInGroupRequest"));
__export(require("./ClientGossipCreateRequest"));
__export(require("./ClientGroup"));
__export(require("./ClientGroupAddGroupMembershipAdminConfirmation"));
__export(require("./ClientGroupAddGroupMembershipAdminRequest"));
__export(require("./ClientGroupAddPersonConfirmation"));
__export(require("./ClientGroupAddPersonRequest"));
__export(require("./ClientGroupChangeNameByAdminConfirmation"));
__export(require("./ClientGroupChangeNameByAdminRequest"));
__export(require("./ClientGroupCreateByAdminConfirmation"));
__export(require("./ClientGroupCreateByAdminRequest"));
__export(require("./ClientGroupDeleteByAdminConfirmation"));
__export(require("./ClientGroupDeleteByAdminRequest"));
__export(require("./ClientGroupExtended"));
__export(require("./ClientGroupExtendedDetail"));
__export(require("./ClientGroupJoinConfirmation"));
__export(require("./ClientGroupJoinRequest"));
__export(require("./ClientGroupLeaveConfirmation"));
__export(require("./ClientGroupLeaveRequest"));
__export(require("./ClientGroupMemberExtended"));
__export(require("./ClientGroupModifyGeoAreasByAdminConfirmation"));
__export(require("./ClientGroupModifyGeoAreasByAdminRequest"));
__export(require("./ClientGroupPendingJoinAcceptConfirmation"));
__export(require("./ClientGroupPendingJoinAcceptRequest"));
__export(require("./ClientGroupPendingJoinDenyConfirmation"));
__export(require("./ClientGroupPendingJoinDenyRequest"));
__export(require("./ClientGroupRemoveGroupMembershipAdminConfirmation"));
__export(require("./ClientGroupRemoveGroupMembershipAdminRequest"));
__export(require("./ClientHappening"));
__export(require("./ClientHappeningParticipationConfirmConfirmation"));
__export(require("./ClientHappeningParticipationConfirmRequest"));
__export(require("./ClientHappeningParticipationRevokeConfirmation"));
__export(require("./ClientHappeningParticipationRevokeRequest"));
__export(require("./ClientHappeningPublishRequest"));
__export(require("./ClientLegalText"));
__export(require("./ClientLegalTextAcceptRequest"));
__export(require("./ClientLegalTextAcceptResponse"));
__export(require("./ClientLegalTextAcceptance"));
__export(require("./ClientLegalTextStatus"));
__export(require("./ClientLikeCommentConfirmation"));
__export(require("./ClientLikeCommentRequest"));
__export(require("./ClientLikePostConfirmation"));
__export(require("./ClientLikePostRequest"));
__export(require("./ClientLocationDefinition"));
__export(require("./ClientLocationRecord"));
__export(require("./ClientLocationRecordsReceivedEvent"));
__export(require("./ClientLogisticsParticipant"));
__export(require("./ClientMasterDataDeletionRequest"));
__export(require("./ClientMediaItem"));
__export(require("./ClientMediaItemPlaceHolder"));
__export(require("./ClientMediaItemSize"));
__export(require("./ClientNewsItem"));
__export(require("./ClientNewsItemPublishRequest"));
__export(require("./ClientOauthAccount"));
__export(require("./ClientOffer"));
__export(require("./ClientOfferChangeRequest"));
__export(require("./ClientOfferCreateRequest"));
__export(require("./ClientOpeningHoursEntry"));
__export(require("./ClientParcelAddress"));
__export(require("./ClientPerson"));
__export(require("./ClientPersonBlockLoginByAdminRequest"));
__export(require("./ClientPersonBlockLoginByAdminResponse"));
__export(require("./ClientPersonBlockRequest"));
__export(require("./ClientPersonCancelChangeEmailAddressByAdminConfirmation"));
__export(require("./ClientPersonCancelChangeEmailAddressByAdminRequest"));
__export(require("./ClientPersonChangeCommunityRequest"));
__export(require("./ClientPersonChangeCommunityResponse"));
__export(require("./ClientPersonChangeEmailAddressByAdminRequest"));
__export(require("./ClientPersonChangeEmailAddressByAdminResponse"));
__export(require("./ClientPersonChangeEmailAddressConfirmation"));
__export(require("./ClientPersonChangeEmailAddressRequest"));
__export(require("./ClientPersonChangeHomeAreaRequest"));
__export(require("./ClientPersonChangeHomeAreaResponse"));
__export(require("./ClientPersonChangeNameByAdminRequest"));
__export(require("./ClientPersonChangeNameByAdminResponse"));
__export(require("./ClientPersonChangeStatusConfirmation"));
__export(require("./ClientPersonChangeStatusRequest"));
__export(require("./ClientPersonCreateByAdminResponse"));
__export(require("./ClientPersonCreateRequest"));
__export(require("./ClientPersonCreateResponse"));
__export(require("./ClientPersonCreateWithRegistrationTokenRequest"));
__export(require("./ClientPersonExtended"));
__export(require("./ClientPersonOwn"));
__export(require("./ClientPersonProfilePictureChangeConfirmation"));
__export(require("./ClientPersonProfilePictureChangeRequest"));
__export(require("./ClientPersonProfilePictureDeleteConfirmation"));
__export(require("./ClientPersonReference"));
__export(require("./ClientPersonReferenceWithEmail"));
__export(require("./ClientPersonRegistrationTokenRequest"));
__export(require("./ClientPersonRegistrationTokenResponse"));
__export(require("./ClientPersonResendVerificationEmailResponse"));
__export(require("./ClientPersonResetLastLoggedInRequest"));
__export(require("./ClientPersonResetPasswordByAdminRequest"));
__export(require("./ClientPersonResetPasswordByAdminResponse"));
__export(require("./ClientPersonSendVerificationMailByAdminRequest"));
__export(require("./ClientPersonSendVerificationMailByAdminResponse"));
__export(require("./ClientPersonSetEmailVerifiedByAdminRequest"));
__export(require("./ClientPersonSetEmailVerifiedByAdminResponse"));
__export(require("./ClientPersonUnBlockRequest"));
__export(require("./ClientPersonUnblockAutomaticallyBlockedLoginByAdminRequest"));
__export(require("./ClientPersonUnblockAutomaticallyBlockedLoginByAdminResponse"));
__export(require("./ClientPersonUnblockLoginByAdminRequest"));
__export(require("./ClientPersonUnblockLoginByAdminResponse"));
__export(require("./ClientPersonUpdateRequest"));
__export(require("./ClientPersonUpdateResponse"));
__export(require("./ClientPersonVerifyEmailAddressRequest"));
__export(require("./ClientPersonVerifyEmailAddressResponse"));
__export(require("./ClientPoolingStation"));
__export(require("./ClientPoolingStationBox"));
__export(require("./ClientPoolingStationBoxClosedEvent"));
__export(require("./ClientPoolingStationBoxOpenedEvent"));
__export(require("./ClientPoolingStationBoxReadyForAllocationResponse"));
__export(require("./ClientPoolingStationBoxReadyForDeallocationResponse"));
__export(require("./ClientPoolingStationBoxScannedReadyForAllocationRequest"));
__export(require("./ClientPost"));
__export(require("./ClientPostChangeConfirmation"));
__export(require("./ClientPostCreateConfirmation"));
__export(require("./ClientPostDeleteConfirmation"));
__export(require("./ClientPostDeleteRequest"));
__export(require("./ClientPostFlagRequest"));
__export(require("./ClientPurchaseOrderItem"));
__export(require("./ClientPurchaseOrderParcel"));
__export(require("./ClientPurchaseOrderReadyForTransportConfirmation"));
__export(require("./ClientPurchaseOrderReadyForTransportRequest"));
__export(require("./ClientPurchaseOrderReceivedEvent"));
__export(require("./ClientPushCategoryUserSetting"));
__export(require("./ClientPushCategoryUserSettingChangeResponse"));
__export(require("./ClientPushEventDocumentation"));
__export(require("./ClientQrCodeLabelCreateRequest"));
__export(require("./ClientRawLocationRecord"));
__export(require("./ClientReceiverPickupPoolingStationBoxReadyForDeallocationRequest"));
__export(require("./ClientReceiverPickupPoolingStationBoxScannedReadyForDeallocationRequest"));
__export(require("./ClientReceiverPickupReceivedPoolingStationRequest"));
__export(require("./ClientReceiverPickupReceivedResponse"));
__export(require("./ClientRemoveRoleAssignmentRequest"));
__export(require("./ClientRemoveRoleAssignmentResponse"));
__export(require("./ClientRoleAssignment"));
__export(require("./ClientRoleInformation"));
__export(require("./ClientSampleEvent"));
__export(require("./ClientSeeking"));
__export(require("./ClientSeekingChangeRequest"));
__export(require("./ClientSeekingCreateRequest"));
__export(require("./ClientSellingPoint"));
__export(require("./ClientSellingPointWithTransports"));
__export(require("./ClientShop"));
__export(require("./ClientShopCreateConfirmation"));
__export(require("./ClientShopCreateRequest"));
__export(require("./ClientShopDeleteConfirmation"));
__export(require("./ClientShopDeleteRequest"));
__export(require("./ClientShopSetOwnerConfirmation"));
__export(require("./ClientShopSetOwnerRequest"));
__export(require("./ClientShopUpdateConfirmation"));
__export(require("./ClientShopUpdateRequest"));
__export(require("./ClientSignature"));
__export(require("./ClientSuggestion"));
__export(require("./ClientSuggestionCategory"));
__export(require("./ClientSuggestionCategoryChangeConfirmation"));
__export(require("./ClientSuggestionCategoryChangeRequest"));
__export(require("./ClientSuggestionChangeRequest"));
__export(require("./ClientSuggestionCreateRequest"));
__export(require("./ClientSuggestionExtended"));
__export(require("./ClientSuggestionStatusChangeConfirmation"));
__export(require("./ClientSuggestionStatusChangeRequest"));
__export(require("./ClientSuggestionStatusRecord"));
__export(require("./ClientSuggestionWithdrawConfirmation"));
__export(require("./ClientSuggestionWithdrawRequest"));
__export(require("./ClientSuggestionWorkerAddConfirmation"));
__export(require("./ClientSuggestionWorkerAddRequest"));
__export(require("./ClientSuggestionWorkerMapping"));
__export(require("./ClientSuggestionWorkerRemoveConfirmation"));
__export(require("./ClientSuggestionWorkerRemoveRequest"));
__export(require("./ClientTemporaryMediaItem"));
__export(require("./ClientTenant"));
__export(require("./ClientTenantAndAppVariantEntry"));
__export(require("./ClientTenantExtended"));
__export(require("./ClientTradingCategory"));
__export(require("./ClientTransport"));
__export(require("./ClientTransportAlternative"));
__export(require("./ClientTransportAlternativeSelectRequest"));
__export(require("./ClientTransportAlternativeSelectResponse"));
__export(require("./ClientTransportAssignmentCancelConfirmation"));
__export(require("./ClientTransportAssignmentCancelRequest"));
__export(require("./ClientTransportDeliveredOtherPersonRequest"));
__export(require("./ClientTransportDeliveredPlacementRequest"));
__export(require("./ClientTransportDeliveredPoolingStationRequest"));
__export(require("./ClientTransportDeliveredReceivedRequest"));
__export(require("./ClientTransportDeliveredReceivedResponse"));
__export(require("./ClientTransportDeliveredRequest"));
__export(require("./ClientTransportDeliveredResponse"));
__export(require("./ClientTransportPickupPoolingStationBoxReadyForDeallocationRequest"));
__export(require("./ClientTransportPickupPoolingStationBoxScannedReadyForDeallocationRequest"));
__export(require("./ClientTransportPickupPoolingStationRequest"));
__export(require("./ClientTransportPickupRequest"));
__export(require("./ClientTransportPickupResponse"));
__export(require("./ClientTransportPoolingStationBoxReadyForAllocationRequest"));
__export(require("./ClientTransportStatusRecord"));
__export(require("./ClientUnlikeCommentConfirmation"));
__export(require("./ClientUnlikeCommentRequest"));
__export(require("./ClientUnlikePostConfirmation"));
__export(require("./ClientUnlikePostRequest"));
__export(require("./ClientUpdateSellingPointForDeliveryRequest"));
__export(require("./ClientUpdateSellingPointForDeliveryResponse"));
__export(require("./ClientUpdateSellingPointsRequest"));
__export(require("./ClientUpdateSellingPointsResponse"));
__export(require("./ClientUpdatedSellingPoint"));
__export(require("./ClientUserDataKeyValueEntry"));
__export(require("./ClientUserGeneratedContentFlag"));
__export(require("./ClientUserGeneratedContentFlagChat"));
__export(require("./ClientUserGeneratedContentFlagComment"));
__export(require("./ClientUserGeneratedContentFlagDeleteFlagEntityByAdminRequest"));
__export(require("./ClientUserGeneratedContentFlagDeleteFlagEntityByAdminResponse"));
__export(require("./ClientUserGeneratedContentFlagDetail"));
__export(require("./ClientUserGeneratedContentFlagForFlagCreator"));
__export(require("./ClientUserGeneratedContentFlagPost"));
__export(require("./ClientUserGeneratedContentFlagResponse"));
__export(require("./ClientUserGeneratedContentFlagStatusChangeRequest"));
__export(require("./ClientUserGeneratedContentFlagStatusChangeResponse"));
__export(require("./ClientUserGeneratedContentFlagStatusRecord"));
__export(require("./DeliveryAdminUIRow"));
__export(require("./DeliveryAndSellingPointAdminUIRow"));
__export(require("./FeatureMetaModel"));
__export(require("./GPSLocation"));
__export(require("./Link"));
__export(require("./ModelAndView"));
__export(require("./OpeningHours"));
__export(require("./OpeningHoursEntry"));
__export(require("./PageOfClientChatMessage"));
__export(require("./PageOfClientGroupExtended"));
__export(require("./PageOfClientGroupMemberExtended"));
__export(require("./PageOfClientPersonExtended"));
__export(require("./PageOfClientPersonReference"));
__export(require("./PageOfClientPost"));
__export(require("./PageOfClientSuggestionExtended"));
__export(require("./PageOfClientTenant"));
__export(require("./PageOfClientTenantExtended"));
__export(require("./PageOfClientUserGeneratedContentFlag"));
__export(require("./PageOfobject"));
__export(require("./Pageable"));
__export(require("./PhoneNumberDetails"));
__export(require("./PoolingStationBoxAdminUIRow"));
__export(require("./PoolingStationBoxAllocationAdminUIRow"));
__export(require("./Sort"));
__export(require("./TimeSpan"));
__export(require("./TransportAlternativeBundleAdminUIRow"));
__export(require("./TransportAssignmentAdminUIRow"));
__export(require("./View"));
__export(require("./WaitingDeadline"));
__export(require("./WaitingDeadlineUpdate"));
